import { Dialog, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import StackInsumosPDF from "./StackInsumosPDF";

const ModalPDFInsumos = ({ open, onClose, variants }) => {
  return (
    <Dialog fullWidth maxWidth="xl" open={open} onClose={onClose}>
      <DialogContent sx={{ p: 2 }}>
        <StackInsumosPDF variants={variants} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalPDFInsumos;
